import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShoppingBag } from 'lucide-react';

export const Hero = () => {
  const { t } = useTranslation();

  const scrollToContact = () => {
    const contact = document.getElementById('contact');
    if (contact) {
      contact.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-[100svh] flex items-center justify-center overflow-hidden pt-16">
      <div 
        className="absolute inset-0 backdrop-blur-sm"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=1920&q=80')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-blue-600/30 to-slate-900/40">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 via-transparent to-blue-600/10 animate-pulse"></div>
      </div>

      <div className="relative container mx-auto px-4 text-center z-10">
        <div className="relative backdrop-blur-sm bg-slate-950/30 rounded-2xl p-8 border border-white/10">
          <div className="mb-8 transform hover:scale-110 transition-transform duration-300">
            <ShoppingBag size={48} className="mx-auto text-blue-300 animate-pulse" aria-hidden="true" />
          </div>
          <div className="mb-2 text-2xl sm:text-3xl md:text-4xl font-bold text-gradient text-glow leading-tight">
            Market Engine
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-6 text-gradient text-glow leading-[1.15] pb-2">
            <span className="block">{t('hero.titleLine1')}</span>
            <span className="block">{t('hero.titleLine2')}</span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-blue-100/90 max-w-2xl mx-auto leading-relaxed font-medium px-4 mb-12">
            {t('hero.subtitle')}
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 px-4">
            <div className="relative group w-full sm:w-auto">
              <div className="absolute -inset-[1px] rounded-lg bg-gradient-to-r from-blue-500/50 to-blue-500/50 opacity-75 blur-sm group-hover:opacity-100 transition-opacity"></div>
              <div className="absolute -inset-[1px] rounded-lg bg-gradient-to-r from-blue-500 to-blue-500 opacity-75 group-hover:opacity-100 transition-opacity"></div>
              <button 
                onClick={scrollToContact}
                className="relative block w-full px-8 py-3 bg-slate-950 rounded-lg text-blue-300 transition-all group-hover:scale-[1.02] text-lg font-semibold"
              >
                {t('hero.startProject')}
              </button>
            </div>
          </div>
        </div>
        
        <div className="absolute top-1/4 left-1/4 w-24 h-24 bg-blue-500/10 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-32 h-32 bg-blue-500/10 rounded-full blur-xl animate-pulse delay-700"></div>
      </div>
    </div>
  );
};
